import React, { useState } from 'react';

import DeviceReturnModal from './DeviceReturnModal';
import Link from '../../common/ui/Link';
import ArrowIcon from '../../../assets/icons/common/ArrowIcon';

import styles from './styles.module.scss';

const DeviceReturn = ({ returnLabel, inspectionStatus, deliveryStatus }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const steps = buildSteps({
    returnLabel: returnLabel,
    deliveryStatus: deliveryStatus,
    inspectionStatus: inspectionStatus,
  });
  const currentStep = getCurrentStep(steps);
  if (!returnLabel) {
    return;
  }
  return (
    <>
      <div>
        <button
          className={styles.returnButton}
          onClick={() => setIsModalOpen(true)}
        >
          Device Return Status <ArrowIcon></ArrowIcon>
        </button>
        <ul className={styles.statuses}>
          {' '}
          {steps.map((item, index) => {
            return <li key={index} className={styles[item.status]}></li>;
          })}
        </ul>
        <p className={styles.stepInfo}>
          <span>{currentStep.position} of 5</span> {currentStep.label}
        </p>
      </div>
      <DeviceReturnModal
        isOpen={isModalOpen}
        steps={steps}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

function getCurrentStep(steps) {
  let index = -1;

  for (let i = 0; i < steps.length; i++) {
    if (steps[i].status === 'success' || steps[i].status === 'error') {
      index = i;
    }
  }

  if (index === -1) return null;

  return {
    keyword: steps[index].keyword,
    status: steps[index].status,
    label: steps[index].label,
    position: index + 1, // 1-based
  };
}

function buildSteps({ returnLabel, deliveryStatus, inspectionStatus }) {
  const steps = [
    {
      keyword: 'LABEL_GENERATED',
      label: (
        <>
          Download the{' '}
          <Link href={returnLabel} target="_blank" colorType={'orange'}>
            Return Label
          </Link>
        </>
      ),
      status: returnLabel ? 'success' : 'pending',
    },
    {
      keyword: 'IN_TRANSIT',
      label: <>Device in transit</>,
      status:
        deliveryStatus === 'TRANSIT'
          ? 'success'
          : deliveryStatus === 'FAILURE'
          ? 'error'
          : 'pending',
    },
    {
      keyword: 'DELIVERED',
      label: <>Received at warehouse</>,
      status: deliveryStatus === 'DELIVERED' ? 'success' : 'pending',
    },
    {
      keyword: 'IN_INSPECTION',
      label: <>Inspection in progress</>,
      status: deliveryStatus === 'DELIVERED' ? 'success' : 'pending',
    },
    {
      keyword: 'INSPECTION_STATUS',
      label:
        inspectionStatus === 'PASSED' ? (
          <>Inspection passed</>
        ) : inspectionStatus === 'FAILED' ? (
          <>
            Inspection failed. Our support team will contact you to discuss the
            next steps.
          </>
        ) : (
          <>Inspection result</>
        ),
      status:
        inspectionStatus === 'PASSED'
          ? 'success'
          : inspectionStatus === 'FAILED'
          ? 'error'
          : 'pending',
    },
  ];

  // forward-propagate success
  let lastSuccessIndex = -1;

  steps.forEach((step, index) => {
    if (step.status === 'success') {
      lastSuccessIndex = index;
    }
  });

  if (lastSuccessIndex >= 0) {
    for (let i = 0; i < lastSuccessIndex; i++) {
      steps[i].status = 'success';
    }
  }

  return steps;
}

export default DeviceReturn;
